export default __webpack_public_path__ + "static/media/time-machine-bg.f4ae196e.svg";